import {
	SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
	SYS_SPACE_FIXED_100,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
	SYS_SPACE_FIXED_350,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledDecisionContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: ${SYS_SPACE_FIXED_350};
	.overflow-hidden {
		overflow: hidden;
	}

	p {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;

export const StyledAutomaticChangeSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
	margin-bottom: ${SYS_SPACE_FIXED_300};
`;

export const StyledAddedHeader = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: ${SYS_SPACE_FIXED_300};
	padding: ${SYS_SPACE_FIXED_150} 0;
`;

export const StyledHeaderContent = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_100};

	.title {
		color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};
	}
`;

export const StyledChildrenContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};

	.label {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;
